//import liraries
import React, { useEffect, useState } from "react";
import { View, Text, TouchableOpacity, Image,} from "react-native";
import QuickLinks from "../Profile/QuickLinks";
import CustomButton from "../../common/CustomButton";
import { getPoolAccountdetail } from "../../api/apiManager";
import CustomInput from "../../common/CustomInput";
import { get } from "lodash";
import * as RootNavigation from "../../utilities/RootNavigation";
import { useLocation } from "react-router-dom";
import useStyles from "./PoolToTag_Styles";

const rechargePattern = /^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/;

const PoolToTag = (props) => {
  const {state} = useLocation();
  const [value, setValue] = useState("1");
  const styles = useStyles();
 const [enterAmount, setEnterAmount] = useState("")
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [maskedAccNum, setMaskedAccNum] = useState("");

  useEffect(() => {
    getPoolAccountDtls()
  }, [])

  const getMaskedNum = (string) => {
    var new_string = string.replace(/\b[\dX][-. \dX]+(\d{4})\b/g, function (match, capture) {
      return Array(match.length - 4).join("X") + capture;
    });
    return new_string
  }

  const getPoolAccountDtls = () => {
    setLoading(true);
    getPoolAccountdetail()
      .then((res) => {
        setLoading(false);
        setData(res || {});
        setMaskedAccNum(getMaskedNum(res?.accountNo || ""))

      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <View style={styles.mainContainer}>
      <View style={styles.container}>
        <TouchableOpacity onPress={() => { RootNavigation.navigate("Profile/PoolAccount/TransferPool") }} >
          <Image
            source={require("../../assets/images/back.png")}
            style={styles.backIcon}
          />
        </TouchableOpacity>
        <Text style={styles.textStyle}>{"Pool To Tag Transfer"}</Text>
      </View>

      <View style={styles.firstContainer}>
        <View style={styles.secondContainer}>
          <View
            style={styles.debitFrom}
          >
            <Text style={{ color: "#5f5f5f", fontSize: 15, fontWeight: "600" }}>
              Pool Account
            </Text>
            <Text style={{
              fontFamily: "Inter",
              fontSize: 15,
              fontWeight: "normal",
              fontStyle: "normal",
              lineHeight: 18,
              letterSpacing: 0,
              textAlign: "left",
              color: "#bbbbbb"
            }}>Debit From</Text>
          </View>

          <View style={styles.containerBorder}>
            <View style={styles.cardContainer}>
              <Image
                source={require("../../assets/images/Card_Image_Pool.png")}
                style={{ width: 82, height: 84 }}
              />
              <View style={styles.innerContainer}>
                <Text style={styles.cardNUmberTextStyle} onPress={() => {
                  setMaskedAccNum(data?.accountNo)
                  setTimeout(() => {
                    setMaskedAccNum(getMaskedNum(data?.accountNo))
                  }, 30000)
                }}>
                  {maskedAccNum}
                </Text>
                <Text style={styles.poolAcTextStyle}>Pool Account No.</Text>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginVertical: 15,
                  }}
                >
                  <Image
                    source={require("../../assets/images/ic_toll.png")}
                    style={{ width: 33, height: 26, color: "#601828" }}
                  />
                  <View
                    style={{
                      marginLeft: 10,
                    }}
                  >
                    <Text style={styles.amountTextStyle}>{"₹"} {get(data, "accountBal", 0).toFixed(2)}</Text>
                    <Text style={[styles.poolAcTextStyle, { paddingTop: 3 }]}>
                      Pool Account Bal.
                    </Text>
                  </View>
                </View>
              </View>
            </View>

            <View style={styles.customButtonView}>
              <View style={styles.buttonViewStyle}>
                <CustomButton
                  text="Recharge"
                  onPress={() => {
                    RootNavigation.navigate("Recharge", {
                      screen: "Recharge",
                      poolAcnt: data?.accountNo,
                    },
                    );
                    global.activeScreen = "Recharge"
                  }}
                />
              </View>
              <View style={styles.buttonViewStyle}>
                <CustomButton
                  text="Transfer"
                  onPress={() => RootNavigation.navigate("Home", { screen: "Transfer", params: { screen: "Transfer" } })}
                />
              </View>
            </View>
          </View>
        </View>

        <View style={styles.thirdContainer}>
          <View style={styles.creditTo}>
            <Text style={{ color: "#5f5f5f", fontSize: 15, fontWeight: "600" }}>
              Amount Distribution
            </Text>
            <Text style={{ color: "#bbbbbb", fontSize: 15 }}>Credit To</Text>
          </View>

          <View style={styles.radioButtonView}>
            <View style={styles.selectionContainerStyle}>
              <TouchableOpacity
                onPress={() => setValue("")}
                style={styles.radiobuttonOutSideStyle}
              >
                {value == "1" ? (
                  <View style={styles.radioButtonInsideStyle} />
                ) : null}
              </TouchableOpacity>
              <Text style={{ fontSize: 13, color: "#02122c", marginLeft: 7 }}>
                {"Fastag"}
              </Text>
            </View>
          </View>

          <View style={styles.selectTag}>
            <CustomInput
              onValueChanged={(e) => setEnterAmount(e)}
              value={enterAmount}
              keyboardType="numeric"
              pattern={/^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/}
              errorMessage={"Enter Valid Amount"}
              maxLength={10}
            />
            <TouchableOpacity style={styles.selectView}
              onPress={() => {
                enterAmount == "" || !rechargePattern.test(enterAmount) ? "" :
                RootNavigation.navigate('Profile/PoolAccount/PoolSelection', {value: state.value, amount: enterAmount})
              }}>
              <Text style={styles.selectText}>Select Tag to debit from</Text>
              <Image source={require("../../assets/images/arrow_right.png")} style={{ width: 7.7, height: 12, resizeMode: "contain", position: "absolute", zIndex: 99, right: 10 }} />
            </TouchableOpacity>
          </View>
          <Text style={styles.perVehicle}> Amount to be distributed (Per Vehicle) </Text>

          <View style={styles.customButtonViewStyle} >
            <CustomButton
              text="Next"
              onPress={() => {
                enterAmount == "" || !rechargePattern.test(enterAmount) ? "" :
               RootNavigation.navigate('Profile/PoolAccount/PoolSelection', {value: state.value,amount: enterAmount })
              }}
              disable={enterAmount == "" || !rechargePattern.test(enterAmount) ? true : false}
            />
          </View>
        </View>
      </View>

      <View>
        <QuickLinks
          navigation={props.navigation}
          activeScreen={"Pool Account Details"}
          setScreen={(layout) => props?.setScreen(layout)}
          setIsManual={(layout) => props?.setSelectedLayout(layout)}
          setSelectedLayout={props?.setSelectedLayout}
        />
      </View>
    </View>
  );
};

//make this component available to the app
export default PoolToTag;
